import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { map, take, Observable, combineLatest } from 'rxjs';

import { AppState } from '@fcom/core';

import { AuthActions, getBookingRef, getPassengers, StatusActions } from '../store';
import { Stage } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class PNRGuard implements CanActivate {
  constructor(
    private store$: Store<AppState>,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([this.store$.pipe(select(getBookingRef)), this.store$.pipe(select(getPassengers))]).pipe(
      take(1),
      map(([booking, passengers]) => {
        if (!booking?.lastName || !booking?.recLoc) {
          this.store$.dispatch(StatusActions.setStage({ stage: Stage.LOGIN }));
          return false;
        }

        // If we have a PNR but have not got data from the upgrade api.
        if (!this.router.url.includes('upgrade/loading') && !passengers?.length) {
          this.store$.dispatch(AuthActions.loadPNR());
        }

        return true;
      })
    );
  }
}
